module.exports = __webpack_public_path__ + "img/rating-rang-1.d63ba788.svg";